export class DocumentHistoryRequestDto {
  webDokuId = '';
  documentId = '';
  archiveFile = '';
  search = '';
  noFullScreen = false;
  readOnly = false;
}
